exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-containers-users-Details-tabs-___styles__container___3-3By {\n  margin: 10px 28px;\n  overflow: auto; }\n", ""]);

// exports
exports.locals = {
	"container": "src-containers-users-Details-tabs-___styles__container___3-3By"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./node_modules","./node_modules/grommet/node_modules"]}!./src/containers/users/Details/tabs/styles.scss
// module id = 459
// module chunks = 0